/* user/actions */
import { action } from "typesafe-actions";
import { User, UserActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(UserActionTypes.FETCH, { id, params, callback });

export const fetchPermission = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(UserActionTypes.FETCH_PERMISSION, { id, params, callback });

export const fetchSuccess = (data: User) =>
  action(UserActionTypes.FETCH_SUCCESS, data);

export const fetchPermissionSuccess = (data: User) =>
  action(UserActionTypes.FETCH_PERMISSION, data);

export const fetchError = (error: string) =>
  action(UserActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: User | null) => unknown
) => action(UserActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: User) =>
  action(UserActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(UserActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(UserActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(UserActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(UserActionTypes.DELETE_ERROR, error);
